<template>
  <div class="cover">
    <div class="net-graph-close">
        <video autoplay loop muted playsinline class="video-background ">
          <source src="/wp-content/interactivos/especial-pesca/intro_c.mp4" type="video/mp4">
        </video> 
      </div>
    <div class="video-cover">
      <div>
        <div class="frame">          
        </div>
      </div>
    </div>
    <div class="meta text-center">
      <div class="headline">
        <h1>
          <span class="top">RESERVAS DE PAPEL</span>
          <span class="second">LOS MARES PROTEGIDOS DEL PERÚ QUE EL ESTADO DESPROTEGE</span>
        </h1>
      </div>  

      
      <div>        
        <div class="row justify-content-center pb-5">
          <div class="col-12 col-md-8 col-lg-8 col-xl-8 text-center">            
            <div class="excerpt">
              <Contenido/>

              <!-- <div>
                <button @click="openVideoMiniDoc()" class="btn-minidoc">Ver minidocumental</button>
              </div> -->
            
            </div>
            
            <div class="excerpt mt-5 pt-5">
              <div class="mb-3 tag">Una investigación de:</div>
              <div class="d-flex justify-content-center">
                <div class="logo-header">
                  <img class="logo-header"  src="@/assets/ef.png" alt="logo">
                </div>

                <div class="logo-header">
                  <img class="logo-header" src="https://www.connectas.org/wp-content/uploads/2024/01/connectas_blanco.svg" alt="logo">
                </div>
              </div>
            </div>
            
           
          </div>
        </div>
      </div>
    </div>
    
	</div>
</template>

<style lang="scss">

  @keyframes slideDownArrow {
    from {
      opacity: 1;
      bottom: 100px;
    }

    to {
      opacity: 0;
      bottom: 0px;
    }
  }

  .cover .btn-audio {
    position: absolute;
    top: 45%;
    width: 100%;
    text-align: center;
    z-index: 999;
    color: #fff;
    animation: blinker 2.5s linear infinite;

    .btn {
      margin: 0 2px;
      padding: 3px;
      border-radius: 0;
      font-size: 15px;
      font-weight: 600;
    }

    &.active {
      display: none;
      pointer-events: none;
    }
  }

  .net-graph-close {
    background-color: #000;
    width: 100%;
    margin: 0 auto;
    left: 0;

    video {
      position: absolute;
      top: -115px;
      display: block;
      width: 100%;
      height: 100vh;
      margin: 0 auto;
      object-fit: cover;
      object-position: top;
    }
  }

  .logo-header {
    height: 75px;
    margin: 0 15px;
    font-size: 13px;
    color: rgb(15, 183, 220);
  }

  .logo-header-foco {
    height: 75px;
    margin: 0 15px;
    font-size: 13px;
    color: rgb(15, 183, 220);
    border-radius: 50%;
  }

  .net-graph-open {
    width: 100%;
    max-width: 820px;
    margin: 0 auto;

    img {
      opacity: 0.8;
    }
  }

  .headline {
    max-width: 720px;
    margin: 0 auto;
    .top {
      padding-top: 45px;
      display: block;
      font-size: 57px;
      color: #fff;
    }
    .second {
      display: block;
      font-size: 41px;
    }
  }


  .btn-audio-small {
    position: absolute;
    right: 0;
    padding: 15px;
    opacity: 0;
    z-index: 90;
    display: none;

    &.active {
      opacity: 1;
      display: block;
      pointer-events: all;
    }

    .btn {
      margin: 0 2px;
      padding: 3px;
      border-radius: 0;
    }

    
  }

  .excerpt {
    .tag {
      font-size: 15px;
    }
  }

  .container-logo {
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .btn-minidoc {
    margin: 15px 0;
    color: #000;
    background-color: #fff;
    border: none;
    padding: 10px 15px;
    font-weight: 400;
    font-size: 15px;
    font-family: "Nunito";
    text-transform: uppercase;

    &:hover {
      background-color: #e3e3e3;
    }
  }

</style>

<script>

  import Contenido from '@/components/Contenido'
  
  export default {
    name: 'CoverHome',
    components: {
      Contenido
    },
    data: () => ({
      popUp: false
    }),
    methods: {
      togglePopUp(){
        this.popUp = !this.popUp
      },
      openVideoMiniDoc() {
        document.querySelector(`#foco_video_minidoc_item`).scrollIntoView({ block: "center", inline: "nearest" })
      },
      showVideo() {
        document.querySelector(`#video-cover-fabrica`).muted = false
        document.querySelector(`#video-cover-fabrica`).style.opacity = 1
        document.querySelector(`.btn-audio`).classList.add(`active`)
        document.querySelector(`.btn-audio-small`).classList.add(`active`)
      },
      hideVideo() {
        document.querySelector(`#video-cover-fabrica`).muted = true
        document.querySelector(`#video-cover-fabrica`).style.opacity = 0.4
        document.querySelector(`.btn-audio`).classList.remove(`active`)
        document.querySelector(`.btn-audio-small`).classList.remove(`active`)
      }
    }
  }
</script>
